export const menuItems = [
  { title: 'Home', linkTo: '/' },
  { title: 'Contact', linkTo: '/contact' },
];
